<template>
  <div>
    <bTable :thData="thData" className="deposit-table" :trData="currentPageData" :loading="loading" :params="params" @size-change="sizeChange" :tip="$t('records.deposit.noDeposit')" :src="src" @current-change="currentChange">
    </bTable>
  </div>
</template>

<script>
import selectScroll from '../../../mixins/selectScroll.js'
// import tableTh from '../../table-config/deposit'
export default {
  mixins: [selectScroll],
  props: ['datas', 'loading', 'count', 'depositThs'],
  data () {
    return {
      currentPageData: [],
      name: 'deposit',
      tip: 'noDeposit',
      src: require('@/assets/images/noDeposit.png'),
      params: {
        selection: false,
        pageSizes: [3, 5, 10, 15],
        pageSize: 15,
        total: 0,
        totalPage: 1
      }
    }
  },
  methods: {
    pageCount (totalnum, limit) {
      return totalnum > 0
        ? totalnum < limit
          ? 1
          : totalnum % limit
            ? parseInt(totalnum / limit) + 1
            : totalnum / limit
        : 0
    },
    sizeChange (val) {
      this.params.pageSize = val
      this.params.totalPage = 1
      // this.$emit('pageSize','deposit',val)
      this.$emit('totalPage-pageSize', [1, this.params.pageSize])
    },
    setPageSize () {
      this.params.totalPage = 1
      this.$emit('totalPage-pageSize', [1, this.params.pageSize])
    },
    currentChange (val) {
      this.params.totalPage = val
      this.$emit('totalPage-pageSize', [
        this.params.totalPage,
        this.params.pageSize
      ])
    },
    computeCurrentPageData (val) {
      this.params.total = this.datas.depositData.length
      var computeData = this.Util.getCurrentPageData(
        this.params.totalPage,
        this.params.pageSize,
        this.datas.depositData
      )
      // 计算总页数
      this.totalPage = this.pageCount(length, this.params.pageSize)
      this.currentPageData = computeData
    }
  },
  mounted () {
    // this.computeCurrentPageData();
  },
  computed: {
    thData () {
      let allTableTh = JSON.parse(JSON.stringify(this.depositThs))
      let arr = []
      for (let i = 0; i < allTableTh.length; i++) {
        let item = {
          label: this.$t('records.deposit.' + allTableTh[i].name),
          name: allTableTh[i].name, // $t('setting.phoneNum')
          width: allTableTh[i].width,
          sortable: allTableTh[i].sortable
        }
        arr.push(item)
      }
      console.log(arr)
      return arr
    }
  },
  components: {},
  watch: {
    'count.deposit': function (val) {
      this.params.total = val
    },
    'datas.depositData': function (val) {
      this.currentPageData = val
      // this.computeCurrentPageData();
    },
    search: function (val) {
      this.params.totalPage = 1
      this.$emit('totalPage-pageSize', [1, this.params.pageSize])
    }
    // "params.totalPage": function () {
    //   this.computeCurrentPageData();
    // },
    // "params.pageSize": function () {
    //   this.computeCurrentPageData();
    // },
  }
}
</script>

<style>
</style>
